import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import wellness1 from "../../assets/wellnesshelp1.png";
import wellness2 from "../../assets/wellnesshelp2.png";
import wellness3 from "../../assets/wellnesshelp3.png";
import wellness4 from "../../assets/wellnesshelp4.png";
import { ArrowRight } from "lucide-react";

const WhoWeHelp = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <>
      {/* Who We Help Section */}
      <section data-aos="fade-up" className="px-4 sm:px-8 md:px-12 py-8 sm:py-12 bg-white">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 items-start">
          {/* Left Side */}
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-[#172633] uppercase mb-4">
              Who We Help
            </h2>
            <p className="text-[#172633] mb-4 sm:mb-6 text-sm sm:text-base">
              We offer therapy and wellness support for:
            </p>

            <ul className="space-y-2">
              {[
                "Children & Teenagers",
                "Adults",
                "Couples & Families",
                "Parents & Caregivers",
                "Working Professionals",
                "Trauma Survivors",
              ].map((item, idx) => (
                <li key={idx} className="flex items-center">
                  <span
                    className={`flex-1 flex items-center gap-2 px-4 py-2 rounded-sm font-bold ${
                      idx === 0
                        ? "bg-gradient-to-r from-[#5CCEC4] to-[#00ADA3] text-white"
                        : "text-[#172633] border-b border-gray-200"
                    }`}
                  >
                    <ArrowRight size={16} />
                    {item}
                  </span>
                </li>
              ))}
            </ul>

            <p className="mt-3 sm:mt-4 text-gray-600 text-sm sm:text-base">
              Anyone seeking personal growth or emotional balance
            </p>
          </div>

          {/* Right Side - Images */}
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-4">
              <img
                src={wellness1}
                alt="Therapy session"
                className="rounded-lg object-cover w-full aspect-square"
              />
              <img
                src={wellness2}
                alt="Couple walking"
                className="rounded-lg object-cover w-full aspect-video"
              />
            </div>

            <div className="flex flex-col gap-4">
              <img
                src={wellness4}
                alt="Walking support"
                className="rounded-lg object-cover w-full aspect-video"
              />
              <img
                src={wellness3}
                alt="Teenager portrait"
                className="rounded-lg object-cover w-full aspect-square"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Therapy Your Way Section */}
      <section data-aos="fade-up" className="bg-[#F6F6F6] px-4 sm:px-8 md:px-12 py-10">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Left Content */}
          <div className="text-center md:text-left max-w-2xl">
            <h2 className="text-2xl sm:text-3xl font-bold text-[#172633] mb-3 uppercase">
              THERAPY, YOUR WAY
            </h2>
            <p className="text-[#172633] text-sm sm:text-base">
              Join us in-person at our Coimbatore center or connect online from anywhere in India 
              or across the globe. Wherever you are, support is just a conversation away.
            </p>
          </div>

          {/* Right Button */}
          <div>
          <a
              href="https://wa.me/919952753900"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-4 sm:px-6 py-3 bg-[#005CA8] text-white font-semibold rounded hover:opacity-90 transition inline-block text-center"
            >
              Let’s Talk
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhoWeHelp;
